import { useState } from 'react';
import { useParams } from 'react-router-dom';
import BottomNav from '../base/BottomNav';
import ClientMoreSheet from './ClientMoreSheet';

interface ClientBottomNavProps {
  clientName: string;
  handleExit: () => void;
  bgImage?: string | null;
  accentColor?: string;
}

export default function ClientBottomNav({ clientName, handleExit, bgImage, accentColor }: ClientBottomNavProps) {
  const { token } = useParams<{ token: string }>();
  const [moreOpen, setMoreOpen] = useState(false);

  const navItems = [
    { to: `/client/${token}`, label: 'Home', icon: 'ri-home-5-line', exact: true },
    { to: `/client/${token}/sessions`, label: 'Sessions', icon: 'ri-camera-line', exact: false },
    { to: `/client/${token}/jobs`, label: 'Jobs', icon: 'ri-folder-image-line', exact: false },
    { to: `/client/${token}/contracts`, label: 'Contracts', icon: 'ri-file-text-line', exact: false },
    { to: `/client/${token}/print-approvals`, label: 'Approvals', icon: 'ri-check-double-line', exact: false },
    { to: `/client/${token}/photobooks`, label: 'Gallery', icon: 'ri-book-2-line', exact: false },
  ];

  return (
    <>
      <BottomNav
        items={navItems}
        moreButton={{
          label: 'More',
          icon: 'ri-apps-line',
          onClick: () => setMoreOpen(true),
          active: moreOpen,
        }}
        bgImage={bgImage}
        accentColor={accentColor}
      />
      <ClientMoreSheet
        open={moreOpen}
        onClose={() => setMoreOpen(false)}
        handleExit={handleExit}
      />
    </>
  );
}